import type { GetFinancialOverviewSummaryParams } from "../types";

export const adminFinancialOverviewKeys = {
  all: ["admin-financial-overview"] as const,
  summary: (params?: GetFinancialOverviewSummaryParams) =>
    [...adminFinancialOverviewKeys.all, "summary", params] as const,
};
